const environment = process.env.NODE_ENV || "production";
const commonData = {
  basePath: "https://hilo-production.nn.r.appspot.com",
  auth: "/auth/v1",
  connect: "/connect/v1",
  admin: "/admin/v1",
};

const envConfig = {
  development: {
    basePath: "https://hilo-production.nn.r.appspot.com",
  },
  staging: {
    basePath: "https://hilo-production.nn.r.appspot.com",
  },
  production: {
    basePath: "https://hilo-production.nn.r.appspot.com",
  },
};
const api = { ...commonData, ...envConfig[environment] };
const configData = { api };
export default configData;
